import { error } from "node:console";

import * as Sentry from "@sentry/react";
import { AxiosError } from "axios";

export const clearLocalStorageOnce = () => {
  const SESSION_MARKER = "tab_session_marker";
  const LAST_SEEN_KEY = "app_last_seen";
  const TIMEOUT = 10000;

  const now = Date.now();

  // clear only once per tab, but always re-start heartbeat on mount/reload
  const alreadyInitialized = sessionStorage.getItem(SESSION_MARKER);

  if (!alreadyInitialized) {
    sessionStorage.setItem(SESSION_MARKER, "true");

    const lastSeen = Number(localStorage.getItem(LAST_SEEN_KEY) || "0");
    const isNewSession = now - lastSeen > TIMEOUT;

    if (isNewSession) {
      // TODO: remove after debugging
      Sentry.addBreadcrumb({
        category: "auth.2fa",
        message: "clearing local storage after first tab was opened",
        level: "info",
        data: {
          source: "useClearLocalStorageOnFirstTab",
          flow: "clearLocalStorage",
        },
      });

      localStorage.clear();
    }
  }

  // heartbeat (while tab is open)
  const interval = setInterval(() => {
    localStorage.setItem(LAST_SEEN_KEY, String(Date.now()));
  }, TIMEOUT);

  localStorage.setItem(LAST_SEEN_KEY, String(now));

  return () => clearInterval(interval);
};
